import {
    AUTO_TRADES_UPDATE,
    RESET_AUTO_TRADES,
    SET_ALERT_MSG,
    SET_ASSET_POPUP,
    SET_BRIDGE_POPUP,
    SET_BWP_POPUP,
    SET_CHOSEN_ASSET,
    SET_CHOSEN_PARTNER_PROGRAM,
    SET_COMPLETED_TUTORIAL,
    SET_CONNECT_WALLET_POPUP,
    SET_EFI_PAY_POPUP,
    SET_FIRST_LOAD,
    SET_HIGH_ROLLERS_PRINCIPAL,
    SET_IFRAME_POPUP,
    SET_INSUFFICIENT_FUNDS_WALLET_POPUP,
    SET_LOADER,
    SET_MAGIC_AUTH,
    SET_MOBILE_POOL_PLAYERS_VISIBLE,
    SET_P2P_POPUP,
    SET_PIX_POPUP,
    // SET_DEMO_MODE,
    SET_POLYGON_DETAILS,
    SET_POOLS_POPUP,
    SET_PRIVATE_KEY_POPUP,
    SET_REDIRECT_BROWSER_POPUP,
    SET_REF_PARAM,
    SET_REV_BRIDGE_ALERT_MSG,
    SET_REV_BRIDGE_POPUP,
    SET_TOPUP_CLOSE_BTN,
    SET_TOPUP_WALLET_POPUP,
    SET_TRADE_MENU,
    SET_TRANSAK_INFO_POPUP,
    SET_UNSUPPORTED_BROWSER_POPUP,
    SET_UTORG_POPUP,
    SET_VALID_BROWSER,
    SET_WIN_RATIO_PRINCIPAL,
    UPDATE_AUTO_TRADE_UI
} from "../actions/main.actions";

let initialState = {
    first_load: false,
    valid_browser: true,
    connect_wallet_popup: false,
    loader: false,
    alert_msg: { type: "", content: "", preventTimeout: false },
    pool_players_hidden: false,
    completed_tutorial: { initial: false, bets: false },
    unsupported_browser_popup: false,
    magic_auth: false,
    iframe_popup: false,
    iframe_src: { src: "", type: "" },
    utorg_popup: false,
    topup_close_btn: false,
    private_key_popup: false,
    chosen_partner_program: "",
    pools_popup: { is_open: false, filter_type: null },
    asset_popup: false,
    chosen_asset: { id: "btc", title: "BTC" },
    ref_param: "",
    bwp_popup: { active: false, content: "" },
    p2p_popup: false,
    redirect_browser_popup: false,
    high_rollers_principal: {},
    win_ratio_principal: {},
    bridge_popup: false,
    rev_bridge_popup: false,
    polygon_details: {
        provider: false,
        matic_transaction: false,
        update_balance: false,
        matic_balance: "0",
    },
    // demo_mode: { active: false, popup: false },
    revBridgeAlertMsg: { type: "", content: "", preventTimeout: false },
    transak_info_popup: { is_active: false, transak_mobile_url: "" },
    pix_popup: false,
    efi_pay_popup: false,
    insufficient_funds_wallet_popup: false,
    trade_menu: false,
    auto_trades: {
        up: { active_ui_popup: false, active_trade_btn_txt: true },
        down: { active_ui_popup: false, active_trade_btn_txt: true },
        // up: {
        // active_ui_popup: false,
        // active_trade_btn_txt: true,
        // [poolId]:{
        //    active: false,
        //    remainingTrades: 0,
        //    numberOfTrades: 0,
        //    bidAmount: 0
        // }
        // },
        //
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_FIRST_LOAD:
            return {
                ...state,
                first_load: action.payload,
            };
        case SET_VALID_BROWSER:
            return {
                ...state,
                valid_browser: action.payload,
            };
        case SET_CONNECT_WALLET_POPUP:
            return {
                ...state,
                connect_wallet_popup: action.payload,
            };
        case SET_COMPLETED_TUTORIAL:
            return {
                ...state,
                completed_tutorial: action.payload,
            };
        case SET_TOPUP_WALLET_POPUP:
            return {
                ...state,
                topup_wallet_popup: action.payload,
            };
        case SET_ALERT_MSG:
            return {
                ...state,
                alert_msg: action.payload,
            };
        case SET_LOADER:
            return {
                ...state,
                loader: action.payload,
            };
        case SET_MOBILE_POOL_PLAYERS_VISIBLE:
            return {
                ...state,
                pool_players_hidden: action.payload,
            };
        case SET_UNSUPPORTED_BROWSER_POPUP:
            return {
                ...state,
                unsupported_browser_popup: action.payload,
            };
        case SET_MAGIC_AUTH:
            return {
                ...state,
                magic_auth: action.payload,
            };
        case SET_P2P_POPUP:
            return {
                ...state,
                p2p_popup: action.payload,
            };
        case SET_BWP_POPUP:
            return {
                ...state,
                bwp_popup: action.payload,
            };
        case SET_IFRAME_POPUP:
            return {
                ...state,
                iframe_src: action.payload,
            };
        case SET_TOPUP_CLOSE_BTN:
            return {
                ...state,
                topup_close_btn: action.payload,
            };
        case SET_UTORG_POPUP:
            return {
                ...state,
                utorg_popup: action.payload,
            };
        case SET_PRIVATE_KEY_POPUP:
            return {
                ...state,
                private_key_popup: action.payload,
            };
        case SET_CHOSEN_PARTNER_PROGRAM:
            return {
                ...state,
                chosen_partner_program: action.payload,
            };
        case SET_ASSET_POPUP:
            return {
                ...state,
                asset_popup: action.payload,
            };
        case SET_CHOSEN_ASSET:
            return {
                ...state,
                chosen_asset: action.payload,
            };
        case SET_POOLS_POPUP:
            return {
                ...state,
                pools_popup: action.payload,
            };
        case SET_REF_PARAM:
            return {
                ...state,
                ref_param: action.payload,
            };
        case SET_REDIRECT_BROWSER_POPUP:
            return {
                ...state,
                redirect_browser_popup: action.payload,
            };
        case SET_HIGH_ROLLERS_PRINCIPAL:
            return {
                ...state,
                high_rollers_principal: {
                    ...state.high_rollers_principal,
                    ...action.payload,
                },
            };
        case SET_WIN_RATIO_PRINCIPAL:
            return {
                ...state,
                win_ratio_principal: {
                    ...state.win_ratio_principal,
                    ...action.payload,
                },
            };
        case SET_BRIDGE_POPUP:
            return {
                ...state,
                bridge_popup: action.payload,
            };
        case SET_REV_BRIDGE_POPUP:
            return {
                ...state,
                rev_bridge_popup: action.payload,
            };
        case SET_POLYGON_DETAILS:
            return {
                ...state,
                polygon_details: { ...state.polygon_details, ...action.payload },
            };
        case SET_REV_BRIDGE_ALERT_MSG:
            return {
                ...state,
                revBridgeAlertMsg: action.payload,
            };
        case SET_TRANSAK_INFO_POPUP:
            return {
                ...state,
                transak_info_popup: { ...state.transak_info_popup, ...action.payload },
            };
        case SET_PIX_POPUP:
            // console.log('PIX popup state:', action.payload);
            return {
                ...state,
                pix_popup: action.payload,
            };
        case SET_EFI_PAY_POPUP:
            return {
                ...state,
                efi_pay_popup: action.payload,
            };
        case SET_INSUFFICIENT_FUNDS_WALLET_POPUP:
            return {
                ...state,
                insufficient_funds_wallet_popup: action.payload,
            };
        case SET_TRADE_MENU:
            return {
                ...state,
                trade_menu: action.payload,
            };
        case RESET_AUTO_TRADES:
            console.log('RESET_AUTO_TRADES - auto_trades:', state.auto_trades);
            const { dirToReset, poolIdToReset } = action.payload;
            console.log('RESET_AUTO_TRADES - dirToReset & poolIdToReset:', dirToReset, poolIdToReset);
            return {
                ...state,
                auto_trades: {
                    ...state.auto_trades,
                    [dirToReset]: {
                        ...state.auto_trades[dirToReset],
                        [poolIdToReset]: {
                            active: false,
                            remainingTrades: 0,
                            numberOfTrades: 0,
                            bidAmount: 0,
                        },
                        // active_ui_popup: false,
                    },
                },
            };
        case AUTO_TRADES_UPDATE:
            console.log('AUTO_TRADES_UPDATE - auto_trades:', state.auto_trades);
            const detailsEntries = Object.entries(action.payload);
            const [dir, details] = detailsEntries[0];
            const [d, poolIdUpdate] = detailsEntries[1];
            return {
                ...state,
                auto_trades: {
                    ...state.auto_trades,
                    [dir]: {
                        ...state.auto_trades[dir],
                        [poolIdUpdate]: {
                            ...state.auto_trades[dir]?.[poolIdUpdate],
                            details: {
                                ...state.auto_trades[dir]?.[poolIdUpdate]?.details,
                                ...details,
                            },
                        },
                    },
                },
            };
        case UPDATE_AUTO_TRADE_UI:
            const payloadEntries = Object.entries(action.payload);
            const [key, value] = payloadEntries[0];
            console.log('UPDATE_AUTO_TRADE_UI - key & value:', key, value);
            return {
                ...state,
                auto_trades: {
                    ...state.auto_trades,
                    [key]: { ...state.auto_trades[key], active_ui_popup: value },
                },
            };
        default:
            return state;
    }
};
